export enum InputTypesEnum {
  TEXT = "text",
  NUMBER = "number",
  PASSWORD = "password",
  EMAIL = "email",
  URL = "url",
  COLOR = "color",
  DATE = "date",
}

export enum InputSizesEnum {
  DEFAULT = "default",
  LARGE = "large",
}

export enum InputVariantsEnum {
  DEFAULT = "default",
  CLEAN = "clean",
}

export enum InputAlignmentsEnum {
  RIGHT = "right",
  LEFT = "left",
}
